import { Select } from '@amzn/awsui-components-react';
import { Shift } from '@amzn/red-velvet-api';
import { useTranslation } from 'react-i18next';

interface ShiftSelectProps {
  shifts: Shift[];
  currentShiftId?: string;
  disabledShiftIds?: string[];
  onShiftChange: (shiftId: string) => void;
}

export const ShiftSelect = ({
  shifts,
  currentShiftId,
  disabledShiftIds = [],
  onShiftChange,
}: ShiftSelectProps) => {
  const { t } = useTranslation(['attendance', 'translation']);

  const options = shifts.map((shift) => ({
    label: shift.name || '',
    value: shift.shiftId || '',
    disabled: disabledShiftIds.includes(shift.shiftId || ''),
  }));

  return (
    <Select
      data-testid="shift-select"
      ariaLabel={t('attendeeTable.selectShift')}
      autoFocus={true}
      expandToViewport={true}
      options={options}
      selectedOption={options.find((opt) => opt.value === currentShiftId) ?? null}
      onChange={(event) => {
        onShiftChange(event.detail.selectedOption.value || '');
      }}
    />
  );
};
